// icon:incognito | Bootstrap https://icons.getbootstrap.com/ | Bootstrap
import * as React from 'react'

function IconIncognito(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 16 16"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M4.736 1.968l-.892 3.269-.014.058C2.113 5.568 1 6.006 1 6.5 1 7.328 4.134 8 8 8s7-.672 7-1.5c0-.494-1.113-.932-2.83-1.205a1.032 1.032 0 00-.014-.058l-.892-3.27c-.146-.533-.698-.849-1.239-.734C9.411 1.363 8.62 1.5 8 1.5c-.62 0-1.411-.136-2.025-.267-.541-.115-1.093.2-1.239.735zm.015 3.867a.25.25 0 01.274-.224c.9.092 1.91.143 2.975.143a29.58 29.58 0 002.975-.143.25.25 0 01.05.498c-.918.093-1.944.145-3.025.145s-2.107-.052-3.025-.145a.25.25 0 01-.224-.274zM3.5 10h2a.5.5 0 01.5.5v1a1.5 1.5 0 01-3 0v-1a.5.5 0 01.5-.5zm-1.5.5c0-.175.03-.344.085-.5H2a.5.5 0 010-1h3.5a1.5 1.5 0 011.488 1.312 3.5 3.5 0 012.024 0A1.5 1.5 0 0110.5 9H14a.5.5 0 010 1h-.085c.055.156.085.325.085.5v1a2.5 2.5 0 01-5 0v-.14l-.21-.07a2.5 2.5 0 00-1.58 0l-.21.07v.14a2.5 2.5 0 01-5 0v-1zm8.5-.5h2a.5.5 0 01.5.5v1a1.5 1.5 0 01-3 0v-1a.5.5 0 01.5-.5z"
      />
    </svg>
  )
}

export default IconIncognito
